var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 396 108",
    width: 396,
    height: 108,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".s0{fill:#202a31}")), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m6 12c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m6 76c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m6 44c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m6 108c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m38 12c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m38 76c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m38 44c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m38 108c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m70 12c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m70 76c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m70 44c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m70 108c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m102 12c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m102 76c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m102 44c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m102 108c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m134 12c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m134 76c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m134 44c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m134 108c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m166 12c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m230 12c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m294 12c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m358 12c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m166 76c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m230 76c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m294 76c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m358 76c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m166 44c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m230 44c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m294 44c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m358 44c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m166 108c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m230 108c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m294 108c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m358 108c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m198 12c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m262 12c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m326 12c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m390 12c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m198 76c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m262 76c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m326 76c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m390 76c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m198 44c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m262 44c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m326 44c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m390 44c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m198 108c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m262 108c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m326 108c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m390 108c-3.3 0-6-2.7-6-6c0-3.3 2.7-6 6-6c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotShape);
export default __webpack_public_path__ + "static/media/dot-shape.950092627955fa09eee9fa4cc1da17ab.svg";
export { ForwardRef as ReactComponent };